module.exports = __webpack_public_path__ + "media/bootstrap-icons/gender-male-0b02f425.svg";